import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { change, submit, isSubmitting } from "redux-form";
import { CREATE, GET_ONE, GET_LIST } from "react-admin";
import { isNil, prop, path, map, isEmpty, filter, head, propEq } from "ramda";
import {
  showNotification,
  Button,
  SaveButton,
  SimpleForm,
  LongTextInput,
  TextInput,
  BooleanInput
} from "react-admin";
import IconCancel from "@material-ui/icons/Cancel";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import dataProviderFactory from "../dataProvider";
import AttachMoney from "@material-ui/icons/AttachMoney";
import { required } from "ra-core";
import styled from "styled-components";
import CircularProgress from '@material-ui/core/CircularProgress';
import {
  Select,
  InputLabel,
  MenuItem,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import { PaymentsClients } from "./boxPaymentsClients";
import { CustomizedTables } from "../components/resumenPayments"

const StyledSelect = styled(Select)`
  width: 265px !important;
`;

const StyledInputLabel = styled(InputLabel)`
  &&& {
    font-size: 16px !important;
  }
`;

const StyledDiv = styled.div(() => ({
  flexDirection: "column",
  display: "flex",
  flexFlow: "nowrap",
  padding: "10px"
}));

const StyledDivBox = styled.div(() => ({
    alignItems: "center",
    maxWidth:"400px",
    display: 'flex',
}));

const StyledDialogTitle = styled.div(()=>({
  display: "flex",
  justifyContent: "space-between",
}))

const StyledSimpleForm = styled(SimpleForm)(({ theme }) => ({
  maxWidth: "350px !important",
}));

class CreateChargeButton extends Component {
  handleValueChange = (element) => {
    this.setState({ [element.target.id]: element.target.value });
  };

  handleValueChangeBool = (element) => {
    this.setState({ [element.target.id]: element.target.checked });
  };

  handleCheckResendConfirm = (event) => {
    this.setState({
      [event.target.name]: event.target.checked
    });
  };

  handleSendEmailCheckChange = event => {
    this.setState({
      [event.target.name]: event.target.checked,
    });
  };

  state = {
    tpa_link: false,
    error: false,
    showDialog: false,
    chargeTypeId: "2",
    // `due` ya viene neto (discount + rewards restados en rentals_due). No restar discount otra vez.
    chargeValue: Number((path(["props", "rental", "due"], this) || 0).toFixed(2)),
    remaining: Number((path(["props", "rental", "due"], this) || 0).toFixed(2)),
    chargeComments: "",
    extraCharge: prop("extraCharge", this.props),
    sendFinalConfirmation: true,
    resend: false,
    discount: Number((path(["props", "rental", "discount"], this) || 0).toFixed(2))
  };

  handleClick = () => {
    this.setState({ showDialog: true });
  };

  handleChangeItem = (element, type) => {
    this.setState({ [type]: element.target.value, tpa_link: false });
  };

  handleCloseClick = () => {
    this.setState({ showDialog: false });
  };

  deleteRentalFromListDom = () => {
    const { rental } = this.props;
    const tableRentalDom = document.getElementById("tours-due-table");
    if(tableRentalDom){
      const tbodyRentalTableDom = tableRentalDom.querySelector('tbody');
      if(tbodyRentalTableDom){
        tbodyRentalTableDom.querySelectorAll('tr').forEach((element, key) => {
          const cells = element.querySelectorAll('td');
          const cellIdRentalValue = cells[0].querySelectorAll('span')[0].textContent;     
          if(rental.id === cellIdRentalValue){
            tableRentalDom.rows[key].remove();
          }
        });
      }
    }
  };

  isChargeFormValid = () => {
    const comments = String(this.state.chargeComments || "").trim();
    return (
      this.state.chargeTypeId !== "" &&
      comments.length > 0 &&
      Number(this.state.chargeValue) > 0
    );
  };

  handleSaveClick = () => {
    const { submit, showNotification } = this.props;
    if (!this.isChargeFormValid()) {
      showNotification("Complete all required fields (including Imt Comments)", "warning");
      return;
    }
    submit("charge-send");
  };

  handleSubmitFail = () => {
    const { showNotification } = this.props;
    showNotification("Complete all required fields (including Imt Comments)", "warning");
  };

  getPaymentErrorMessage = (error) => {
    if (!error) {
      return "Error al crear el cargo";
    }
    const body = error.body;
    if (body) {
      if (typeof body === "string") {
        return body;
      }
      if (body.message) {
        return body.message;
      }
      if (body.error) {
        return body.error;
      }
      if (body.details) {
        return body.details;
      }
    }
    return error.message || "Error al crear el cargo";
  };

  handleSubmit = async () => {
    const { history, rental, showNotification } = this.props;
    const bodyRequest = {
      id: rental.id,
      data: {
        id: this.props.rental.id,
        value: this.state.chargeValue,
        discount: this.state.discount,
        comments: this.state.chargeComments,
        tpaLink: this.state.tpa_link,
        chargeTypeId: this.state.chargeTypeId,
        extraCharge: this.state.extraCharge,
        sendFinalConfirmation: this.state.sendFinalConfirmation,
        resend: this.state.resend,
      },
    };
    try {
      const dataProvider = await dataProviderFactory("rest");
      await dataProvider(CREATE, "rentals/generate_payment", bodyRequest);

      showNotification("Charge created with success");
      if (this.state.remaining === this.state.chargeValue) {
        this.deleteRentalFromListDom();
      }
      this.setState({
        tpa_link: false,
        extraCharge: true,
        showDialog: false,
        chargeValue: 0,
        discount: 0,
        chargeTypeId: 2,
        chargeComments: "",
      });
      if (!isNil(history) && history.history) {
        history.history.replace(
          `/${rental.type === 1 ? "tour_due_list" : "rentals_due"}`
        );
      }
    } catch (error) {
      showNotification(this.getPaymentErrorMessage(error), "error");
    }
  };

  getStripeType(rental) {
    const tourId = path(["booking", "tour_id", rental]);

    if ((!isNil(tourId) && tourId > 0) || !isNil(prop("type", rental))) {
      if (!isNil(prop("booking", rental))) {
        if (!isNil(rental.booking) && rental.type === 1) {
          return rental.booking.p4m ? "p4m" : "tours";
        }
        if (!isNil(rental.booking) && rental.type === 2) {
          return rental.location_id_1 === "3" ? "rentals_pt" : "rentals";
        }
      } else {
        if (rental.type === 1 && rental.p4m === 1) {
          return "p4m";
        }
        if (rental.type === 1 && rental.p4m === 0) {
          return "tours";
        }
        if (rental.type === 2 && rental.location_name_1 === "lisbon") {
          return "rentals_pt";
        }
        if (rental.type === 2 && rental.location_name_1 !== "lisbon") {
          return "rentals";
        }
      }
    }
  }

  isUserStripe = () => {
    const { rental } = this.props;
    let stripToUse = null;
    if (!isNil(rental)) {
      const stripeType = this.getStripeType(rental);
      if (stripeType !== "p4m") {
        if (!isNil(prop("driver", rental))) {
          stripToUse = prop(`stripe_${stripeType}`, rental.driver);
        } else {
          stripToUse = prop(`stripe_${stripeType}`, rental);
        }
      }
    }
    return !isNil(stripToUse);
  };

  async getRecord() {
    const id = this.props.rental.id;
    const dataProvider = await dataProviderFactory("rest");
    await dataProvider(GET_ONE, "tour_clients", {
      id: id,
    }).then((response) => {
      this.state.record = response.data;  
    });
    const price = await this.getTourPrice(this.state.record);
    //this.state.price = price;
    this.setState({ 
      price: price, 
      clientData: this.state.record.clientData, 
      clientEmail: this.state.record.booking.r_email 
    })


  }

  async getTourPrice(tour){
    const priceDate = tour.booking.price_date
    const tour_id = tour.booking.tour_id
    const dataProvider = await dataProviderFactory("rest");

    const vehicleModels = await dataProvider(GET_LIST, "vehicle_models", {
      filter: { active: true, type: "2_2" },
      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: "order", order: "ASC" }
    });

    const responseTourPrices = await dataProvider(GET_LIST, "prices", {
      filter: {
        for_date: priceDate,
        for_tour_id: tour_id,
      },
      pagination: {
        page: 1,
        perPage: 99999,
      },
      sort: {}
    });
    let passengerPrice = 0
    let singlePrice = 0
    let tourTotal = prop(
      "price",
      head(filter(propEq("price_item_sub_type", "tour_total"), responseTourPrices.data))
    );
   
    if(!isNil(tour.booking.p_first_name) && !isEmpty(tour.booking.p_last_name)){
      passengerPrice = prop(
        "price",
        head(
          filter(propEq("price_item_sub_type", "tour_passenger"), responseTourPrices.data)
        )
      );
    }
    if(tour.r_single || tour.booking.r_single){
      singlePrice = prop(
        "price",
        head(
          filter(propEq("price_item_sub_type", "tour_single"), responseTourPrices.data)
        )
      )
    }
    return {tourTotal, passengerPrice, singlePrice, prices: responseTourPrices, models: vehicleModels}
  }

  async componentDidMount() { 
    let path = window.location.pathname;
    if (this.props.history) {
      if (this.props.history.basePath) {
        path = this.props.history.basePath;
      } else if (this.props.history.location && this.props.history.location.pathname) {
        path = this.props.history.location.pathname;
      }
    }
    this.setState({ path: path });
    if (path === "/tour_due_list") {
      this.getRecord();
    }
   
  }

  render() {
    const chargeTypes = [
      { _id: "1", description: "Stripe" },
      { _id: "2", description: "Other (Money, bank transfer)" },
    ];

    const { rental } = this.props;
    // console.log(record)
    // let haveStripe = this.isUserStripe();

    const { showDialog } = this.state;
    const { isSubmitting } = this.props;
    return (
      <Fragment>
        <Button label="Charge" onClick={this.handleClick}>
          <AttachMoney titleAccess="Charge" cursor="pointer" />
        </Button>
        <Dialog
          //fullWidth={true}
          maxWidth={"lg"}
          open={showDialog}
          onClose={this.handleCloseClick}
          aria-label="Charge"
          style={{ width: '1000px !important' }}
        ><StyledDiv style={{ display: this.state.path !== "/tour_due_list" ? 'flow' : 'flex', padding: '5px !important' }}>
          <div style={{ maxWidth: "800px"}}>
            <DialogTitle>
              <StyledDialogTitle>
                <div > {/* style={{ maxWidth: "350px"}}*/}
                  { this.state.path === "/tour_due_list" ? "": `Charge - ` }
                  { `${
                    !isNil(rental.client_name)
                      ? rental.client_name
                      : `${prop("r_first_name", prop("booking", rental))} ${prop(
                          "r_last_name",
                          prop("booking", rental)
                        )} `
                  } for ${
                    rental.type === 1
                      ? `${
                          rental.tour_name
                            ? rental.tour_name
                            : this.props.rental.booking.tour.tour_name.tour_name_en
                        }`
                      : "Rental"
                  }`}{" "}
                  <br /> 
                  <h5>{`Start Date ${rental.date_1} to ${rental.date_2}`}</h5>                
                </div>               
              </StyledDialogTitle>
            </DialogTitle>
            <DialogContent style={{ display: "flex", flexFlow: "column" }}>
              <StyledSimpleForm
                form="charge-send"
                resource="charges"
                onSubmit={this.handleSubmit}
                onSubmitFail={this.handleSubmitFail}
                toolbar={null}
                destroyOnUnmount={true}
                style={{ width: this.state.path !== "/tour_due_list" ? '100%' : '450px' }}
              >
                <StyledInputLabel htmlFor="charge-simple">
                  Charge Type *
                </StyledInputLabel>
                <StyledSelect
                  onChange={(e) => this.handleChangeItem(e, "chargeTypeId")}
                  inputProps={{
                    name: "charge",
                    id: "charge-simple",
                  }}
                  // disabled={
                  //   rental.old_system || !haveStripe || rental.from_agency
                  // }
                  disabled={true}
                  optionValue="_id"
                  validate={required()}
                  value={this.state.chargeTypeId}
                >
                  {map((item) => {
                    return (
                      <MenuItem key={item._id} value={item._id}>
                        {item.description}
                      </MenuItem>
                    );
                  }, chargeTypes)}
                </StyledSelect>

                <TextInput
                  source="chargeValue"
                  label="Charge Value (Euros)" 
                  type="number"
                  defaultValue={this.state.chargeValue}
                  onChange={this.handleValueChange}
                  validate={required()}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                {this.state.discount > 0 && ( 
                  <h5>{`Discount applied ${this.state.discount} `}</h5>)
                }
                {/* comenrtario poara registrar en imt no factura  */}
                <LongTextInput
                  source="chargeComments"
                  label="Imt Comments"
                  type="text"
                  onChange={this.handleValueChange}
                  validate={required()}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                {this.state.chargeTypeId === "1" && (
                  <BooleanInput
                    label="Pay through link"
                    source="tpa_link"
                    onChange={this.handleValueChangeBool}
                  />
                )}

                {rental.type === 1 && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="sendFinalConfirmation"
                        checked={this.state.sendFinalConfirmation}
                        onChange={(e) => this.handleSendEmailCheckChange(e)}
                        value="sendFinalConfirmation"
                      />
                    }
                    label="Send final confirmation e-mail"
                  />
                )}
              </StyledSimpleForm>
              <div style={{ marginTop: '1rem', padding: "0px 1rem"}}>
                { this.state.path === "/tour_due_list" ? 
                  <React.Fragment>
                    <div>{`Bank information `}<br></br>{this.state.clientData}</div>
                    <div>{`Rider Email `} <br></br>{this.state.clientEmail} </div>
                  </React.Fragment>
                  : ""
                } 
              </div> 
            </DialogContent>   
            <DialogActions>
              <SaveButton
                saving={isSubmitting}
                onClick={this.handleSaveClick}
                disabled={
                  isSubmitting ||
                  !this.isChargeFormValid()
                }
              />
              <Button label="ra.action.cancel" onClick={this.handleCloseClick}>
                <IconCancel />
              </Button>
            </DialogActions>
          </div>
          { this.state.path === "/tour_due_list" ?
            <StyledDivBox>
              {this.state.price !== "" ?  <PaymentsClients data={this.state.record} price={this.state.price} isOpen={true}/> : <CircularProgress />}           
            </StyledDivBox>  
            : ""
          }
          { this.state.path === "/tour_due_list" ? 
            <React.Fragment>
              <StyledDivBox>
                {this.state.price !== "" ?  <CustomizedTables data={this.state.record} prices={this.state.price}/> : <CircularProgress />}                   
              </StyledDivBox>
            </React.Fragment>
            : ""
          }              
        </StyledDiv>
        </Dialog>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  isSubmitting: isSubmitting("charge-send")(state),
});

const mapDispatchToProps = {
  change,
  showNotification,
  submit,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateChargeButton);



// WEBPACK FOOTER //
// ./src/components/createCharge.js